import { render, staticRenderFns } from "./CalendarJieQi.vue?vue&type=template&id=05b36d04&"
import script from "./CalendarJieQi.vue?vue&type=script&lang=js&"
export * from "./CalendarJieQi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports